export default "__VITE_ASSET__DamAjiTX__"